import React from 'react';

import ContentWrapper from '../components/content-wrapper';
import TitledComponent from '../components/titled-component';
import { CheckBox } from '../components/inline-input';
import { Field, propTypes, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled1 from 'react-emotion';
export const medicalStatus = [
  '无',
  '肺炎',
  '支气管炎',
  '支气管哮喘',
  '高血压',
  '冠心病',
  '心绞痛',
  '心肌梗死',
  '胃炎',
  '肠炎',
  '消化性溃疡',
  '肝炎（慢性乙肝）',
  '肝硬化',
  '肾炎',
  '肾衰',
  '贫血',
  '糖尿病',
  '类风湿关节炎',
  '中风',
  '甲亢',
  '甲减',
  '肿瘤',
];
const Span1 = styled1.span`
  display: inline-block;
  width: 100%;
  text-decoration:none;
  font-size: 40px;
  padding-top:10px;
  line-height: 1;
  text-align: center;
  background-color:#22a7f0;
  color: white;
`;
const aherf={
    textDecoration:'none',
    color: 'white',
    lineHeight: '1.5'
}
class _MedicalHistoryForm extends React.Component {
  renderCheckBoxList({ input: { value, onChange }, }) {
    const toggleIndex = v => (
      value.indexOf(v) >= 0 ? [
        ...value.slice(0, value.indexOf(v)), ...value.slice(value.indexOf(v) + 1),
      ] : [
        ...value, v
      ]
    );
    return(
        <div>
    <Span1><a href="javascript:history.back(-1)" style={aherf} >返回</a> </Span1>
    {[ <CheckBox
        compact
        key={0}
        checked={!value || !value.length}
        onClick={() => onChange([])}
      >
        {medicalStatus[0]}
      </CheckBox>,
      ...medicalStatus.slice(1).map((l, idx) => (
        <CheckBox
          compact
          key={l}
          checked={value.indexOf(idx + 1) >= 0}
          onClick={() => onChange(toggleIndex(idx + 1))}
        >
          {l}
        </CheckBox>
      ))]}
</div>
         );
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <form onSubmit={handleSubmit} style={{ height: '100%' }}>
        <Field name='selected' component={this.renderCheckBoxList} />
      </form>
    );
  }
}

_MedicalHistoryForm.defaultProps = {
  children: null,
};

_MedicalHistoryForm.propTypes = {
  ...propTypes,
  children: PropTypes.node
};

export const MEDICAL_HISTORY_FORM_NAME = 'medical_history';

const MedicalHistoryForm = connect(state => ({
  initialValues: {
    selected: state.user.medicalHistoryInitial,
  }
}))(reduxForm({
  form: MEDICAL_HISTORY_FORM_NAME, // a unique name for this form
  destroyOnUnmount: false,
  initialValues: {
    selected: [],
  }
})(_MedicalHistoryForm));

class MedicalHistory extends TitledComponent {
  render() {
    return (
      <ContentWrapper>
        <MedicalHistoryForm />
      </ContentWrapper>
    );
  }
}

MedicalHistory.defaultProps = {
  title: '有无病史（多选）',
};

export default MedicalHistory;



// WEBPACK FOOTER //
// ./src/scene/medical-history.jsx